import React from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { BsDatabaseFillAdd } from 'react-icons/bs';
import NodeCardShell from '../Components/NodeCardShell';
import { describeRequestLine } from '../Components/nodeSummary';
import NodeOutputRow, { NodeOutputGroup } from '../Components/NodeOutputRow';

const QUERY_API_NODE_COLOR = '#7ECCD8';

const QueryApi = ({ data, isConnectable, id, selected }) => {
  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  return (
    <NodeCardShell
      icon={BsDatabaseFillAdd}
      color={QUERY_API_NODE_COLOR}
      typeName="Consulta API"
      title={data.title ?? 'Consulta API'}
      summary={describeRequestLine(data.protocol, data.url_api)}
      trigger={data.user_response}
      error={data?.error}
      selected={selected}
      first={data.first}
      handles={
        <>
          {!data.first && data.saved && (
            <Handle
              type="target"
              position={Position.Top}
              isConnectable={isConnectable}
              id={`target-${id}`}
              style={{ backgroundColor: QUERY_API_NODE_COLOR }}
            />
          )}
          {data.saved && (
            <Handle
              type="source"
              position={Position.Bottom}
              id={`source-${id}`}
              isConnectable={isConnectable}
              style={{ backgroundColor: QUERY_API_NODE_COLOR }}
            />
          )}
        </>
      }
    >
      {data.saved && (
        <NodeOutputGroup>
          <NodeOutputRow
            label={data.succes}
            color="#4ADE80"
            handleId={`source-queryApi-succes`}
            isConnectable={isConnectable}
          />
          <NodeOutputRow
            label={data.failed}
            color="#F87171"
            handleId={`source-queryApi-failde`}
            isConnectable={isConnectable}
          />
        </NodeOutputGroup>
      )}
    </NodeCardShell>
  );
};

export default React.memo(QueryApi);
